import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IUserLogGroup } from 'bets.oddprovider.lib.common.ts/models'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import axios from '../../apiClient/axios'
import { UsersLogsGroupsApiClient } from '../../apiClient/usersLogsGroups'

export interface IUsersLogsGroupsAction extends IDefaultAction {
  payload?: IUserLogGroup[],
}

export interface IUsersLogsGroupsState extends IDefaultState {
  payload?: IUserLogGroup[],
}

const initState: IUsersLogsGroupsState = {}

export const usersLogsGroupsStateLoadFromApi = createAsyncThunk(
  'usersLogsGroupsStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<IUserLogGroup>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {
    const apiResult: IApiClientResult<ApiResponseGetListData<IUserLogGroup>> = await new UsersLogsGroupsApiClient(axios).get({
      where: arg.where,
      sort: { name: 1 }
    })

    if (apiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(apiResult.msg)

    if (arg.onFinally)
      arg.onFinally()
    return apiResult
  }
)

export const usersLogsGroupsSlice = createSlice({
  name: 'usersLogsGroupsSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(usersLogsGroupsStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(usersLogsGroupsStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.data?.payload
    })
    builder.addCase(usersLogsGroupsStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const { clear: clearUserLogsGroups } = usersLogsGroupsSlice.actions
export default usersLogsGroupsSlice.reducer